import {useDatxPathGenerator} from '../util/routing'
import {useNavigate, useParams} from 'react-router-dom'
import {
    useGetItemsExtractionFileLinkMutation
} from '../search/searchResultPage/components/ItemsExtraction/rtkExtractionItems'
import {ROUTES} from '../constants/routing'
import React, {useEffect} from 'react'

export const DownloadItemsExtractionFileLink = () => {
    const {fileId} = useParams()
    const navigate = useNavigate()
    const generatePath = useDatxPathGenerator()
    const [getFileLink] = useGetItemsExtractionFileLinkMutation()

    useEffect(() => {
        if (!fileId) return
        getFileLink({fileId})
        navigate(generatePath(ROUTES.welcome.path))
    }, [fileId])

    return <></>
}